import f from "./index216.mjs";
function b(i, l) {
  const s = f({}, l);
  return Object.keys(i).forEach((t) => {
    if (t.toString().match(/^(components|slots)$/))
      s[t] = f({}, i[t], s[t]);
    else if (t.toString().match(/^(componentsProps|slotProps)$/)) {
      const n = i[t] || {}, c = l[t];
      s[t] = {}, !c || !Object.keys(c) ? s[t] = n : !n || !Object.keys(n) ? s[t] = c : (s[t] = f({}, c), Object.keys(n).forEach((e) => {
        s[t][e] = b(n[e], c[e]);
      }));
    } else s[t] === void 0 && (s[t] = i[t]);
  }), s;
}
export {
  b as default
};
